import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const steps = [{
  number: '01',
  title: 'CLARITATE',
  description: 'În prima sesiune îți explic exact ce poți obține în instanță și ce nu, bazat pe situația ta reală. Fără termeni juridici grei. Cu răspunsuri directe la fricile tale concrete.'
}, {
  number: '02',
  title: 'STRATEGIE',
  description: 'Construim împreună planul juridic adaptat cazului tău, nu un șablon general. Tu decizi ce variante vrei să urmărim, eu îți spun ce este realizabil și care este cel mai bun traseu.'
}, {
  number: '03',
  title: 'PROTECȚIE',
  description: 'Mă ocup de toate actele, de reprezentarea ta la fiecare termen de judecată și de comunicarea permanentă. Știi în orice moment ce se întâmplă în dosarul tău și ce urmează.'
}];
export function MethodSection() {
  return <section className="bg-cream py-20 px-6" data-id="element-114">
      <div className="max-w-7xl mx-auto" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-116">
          <h2 className="text-text-dark font-heading text-4xl md:text-5xl font-bold mb-6" data-id="element-117">
            Metoda celor <span className="text-gold" data-id="element-118">3 Pași</span>: Claritate.
            Strategie. Protecție.
          </h2>
          <p className="text-text-dark-secondary font-body text-lg leading-relaxed max-w-4xl mx-auto" data-id="element-119">
            Procesul prin care înțelegi ce drepturi ai, construim împreună o
            strategie juridică personalizată și te reprezint pas cu pas până la
            finalizarea dosarului tău.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 items-start relative" data-id="element-120">
          {steps.map((step, index) => <Fragment key={index} data-id="element-121">
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="relative" data-id="element-122">
                <div className="text-center" data-id="element-123">
                  <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gold/10 border-2 border-gold mb-6" data-id="element-124">
                    <span className="text-gold font-heading text-3xl font-bold" data-id="element-125">
                      {step.number}
                    </span>
                  </div>
                  <h3 className="font-label text-lg uppercase tracking-label text-text-dark mb-4" data-id="element-126">
                    {step.title}
                  </h3>
                  <p className="font-body text-base text-text-dark-secondary leading-relaxed" data-id="element-127">
                    {step.description}
                  </p>
                </div>
              </motion.div>

              {index < steps.length - 1 && <div className="hidden md:flex items-center justify-center absolute top-10" style={{
            left: `${(index + 1) * 33.33 - 16.66}%`
          }} data-id="element-128">
                  <ArrowRightIcon className="w-8 h-8 text-gold" strokeWidth={1.5} data-id="element-129" />
                </div>}
            </Fragment>)}
        </div>
      </div>
    </section>;
}